const ForgetPassword = () => {
  return (
    <div className="forget-password">
      <p>Forget Password!</p>
    </div>
  );
};

export default ForgetPassword;
